export const environments = {
  local: 'Local',
  test: 'Testing',
  staging: 'Staging',
  prod: 'Production',
  development: 'Development'
};
